import { Component, HostListener, inject, OnInit } from '@angular/core';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';

import { TokenService } from './auth/services/token/token.service';
import { TranslateService } from './shared/translate/translate.service';
import { ThemeService } from '@shared/services/theme/theme.service';
import { ColorService } from '@shared/services/theme/color.service';
import { SplashScreen } from '@capacitor/splash-screen';
import { Capacitor } from '@capacitor/core';
import { DeviceService } from '@shared/services/device/device.service';
import { FiltroClienteService } from '@shared/services/filtro-cliente/filtro-cliente.service';
import { EdgeToEdge } from '@capawesome/capacitor-android-edge-to-edge-support';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  imports: [IonRouterOutlet, IonApp],
})
export class AppComponent implements OnInit {
  private translateService = inject(TranslateService);
  private token = inject(TokenService);
  private themeService = inject(ThemeService);
  private colorService = inject(ColorService);
  private _device = inject(DeviceService);
  private _clientes = inject(FiltroClienteService);

  constructor() {
    this.token.loadToken();
    this.translateService.initLang();
    this._device.initBreakpoints();
  }

  ngOnInit(): void {
    this._clientes.hayClienteSeleccionado();
  }

  @HostListener('document:readystatechange', ['$event'])
  async onReadyStateChanged(event: any) {
    if (event.target.readyState === 'complete' && Capacitor.getPlatform() !== 'web') {
      await SplashScreen.hide();
      await EdgeToEdge.enable();
      this.themeService.initTheme();
      this.colorService.initColor();
    }
  }
}
